import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { PixelPlaceholderLoader } from "@similarweb/ui-components";

import { FlexColumn, FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

const { carbon } = colorsPalettes;

export const DataRowContent = styled(FlexColumn)`
    height: 100px;
    justify-content: center;
    border-bottom: 1px solid ${carbon[50]};
`;

export const DataRowContainer = styled(FlexColumn)`
    height: 100px;
    padding: 0 24px;
    &:last-child {
        ${DataRowContent} {
            border-bottom: none;
        }
    }
`;

export const DataRowTitle = styled(FlexRow)`
    align-items: center;
    margin-bottom: 8px;
`;

export const DataRowWithAddToDashboarTitle = styled(FlexRow)`
    align-items: center;
`;

export const DataTitle = styled.div`
    ${setFontVariant("subTitle3Alt", carbon[500])};
    text-wrap: nowrap;
`;

export const DataRowValue = styled(FlexRow)`
    align-items: center;
    > :first-child {
        margin-right: 12px;
    }
    .data-row-change-value {
        ${setFontVariant("input2")}
        > :first-child {
            margin-right: 4px;
        }
    }
`;

export const DataValue = styled.div`
    ${setFontVariant("h5", carbon[500])}
`;

export const DataGrowthBasis = styled.div`
    ${setFontVariant("caption", carbon[300])}
    line-height: 16px;
`;

export const DataDescription = styled.div`
    ${setFontVariant("caption", carbon[300])}
`;

export const DataDescriptionLoader = styled(PixelPlaceholderLoader)`
    margin-top: 8px;
`;
